import { MutationFunction } from "react-query";
import { UrlQuery, useBackendUrl } from "./useBackendUrl";

export interface ErrorResponse {
  error: string;
}

/* R is the return type, t the type of the query body  */
export function useBackendMutationFunction<R, T>(
  path: string,
  method: "POST" | "DELETE" | "PATCH" = "POST",
  params: UrlQuery = {}
) {
  const url = useBackendUrl(path, params);

  const mutationFn: MutationFunction<R, T> = async (body: T) => {
    let response = await fetch(url, {
      method: method,
      body: body ? JSON.stringify(body) : undefined,
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const error: ErrorResponse = (await response.json()) as ErrorResponse;
      throw new Error(error.error);
    }
    if (response.status == 204) {
      return {} as R;
    }

    return (await response.json()) as R;
  };

  return mutationFn;
}
